import React from "react";
import Navbar from "./components/landing/Navbar";
import Hero from "./components/landing/Hero";
import Testimonials from "./components/landing/Testimonials";
import DashboardPreview from "./components/landing/DashboardPreview";
import WhyBigBull from "./components/landing/WhyBigBull";
import VipSection from "./components/landing/VipSection";
import PublicSignals from "./components/landing/PublicSignals";
import FinalCTA from "./components/landing/FinalCTA";
import Footer from "./components/landing/Footer";

function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#04060a] text-[#e9eef7]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Testimonials />
        <DashboardPreview />
        <WhyBigBull />
        <VipSection />
        <PublicSignals />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
